<template>
  <div>
      <button @click="$emit('regresar')" class="btn-volver">← Menú principal</button>

    <h3>Usuarios</h3>
    <form @submit.prevent="crearUsuario">
      <input v-model="nuevo.username" placeholder="Usuario" required />
      <input v-model="nuevo.password" placeholder="Contraseña" required />
      <select v-model="nuevo.role">
        <option value="stand">stand</option>
        <option value="superadmin">superadmin</option>
      </select>
      <select v-model="nuevo.stand_id">
        <option value="">-- Sin stand --</option>
        <option v-for="s in stands" :key="s.id" :value="s.id">{{ s.name }}</option>
      </select>
      <button type="submit">Agregar</button>
    </form>
    <table>
      <thead>
        <tr>
          <th>Usuario</th>
          <th>Rol</th>
          <th>Stand</th>
          <th>Acciones</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="u in usuarios" :key="u.id">
          <td>{{ u.username }}</td>
          <td>{{ u.role }}</td>
          <td>{{ u.stand_name || '-' }}</td>
          <td>
            <button @click="eliminarUsuario(u.id)">Eliminar</button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import axios from 'axios'
export default {
  props: ['token'],
  data() {
    return {
      usuarios: [],
      stands: [],
      nuevo: { username: '', password: '', role: 'stand', stand_id: '' }
    }
  },
  async mounted() {
    await this.cargarUsuarios()
    await this.cargarStands()
  },
  methods: {
    async cargarUsuarios() {
      const res = await axios.get('/api/users', { headers: { Authorization: 'Bearer ' + this.token } })
      this.usuarios = res.data
    },
    async cargarStands() {
      const res = await axios.get('/api/stands', { headers: { Authorization: 'Bearer ' + this.token } })
      this.stands = res.data
    },
    async crearUsuario() {
      await axios.post('/api/users', this.nuevo, { headers: { Authorization: 'Bearer ' + this.token } })
      this.nuevo = { username: '', password: '', role: 'stand', stand_id: '' }
      await this.cargarUsuarios()
    },
    async eliminarUsuario(id) {
      if (!confirm('¿Eliminar usuario?')) return
      await axios.delete('/api/users/' + id, { headers: { Authorization: 'Bearer ' + this.token } })
      await this.cargarUsuarios()
    }
  }
}
</script>
